export default __webpack_public_path__ + "static/media/14.52c85414.jpeg";